<template>
  <div>
    <a-row style="text-align: right;">
      <a-button type="primary" @click="showHistModal">Histórico</a-button>
    </a-row>
    <a-row>
      &nbsp;
    </a-row>
    <g-datatable :columns="reportDt.columns"
                 :endpoint="reportDt.endpoint"
                 :tableConfig="reportDt.tableConfig"
                 :actions="reportDt.actions"
                 @action="reportDtAction"
    ></g-datatable>

    <a-tabs defaultActiveKey="1">
      <a-tab-pane :tab="'EJECUTAR REPORTE ' + reporteSeleccionado.name" key="1">
        <a-card>
          <a-spin tip="Programando reporte..." :spinning="loading">
            <a-form-model @submit.native.prevent="programarReporte" :model="execValues" ref="reportForm">
              <a-row :gutter="[16,16]">
                <template v-for="param in reporteSeleccionado.params">
                  <a-col :span="8" :xs="12" :sm="8">
                    <a-form-model-item
                      :rules="[{ required: param.required, message: 'Valor requerido' }, {validator: (rule, value, callback) => { return custommParamValidator(rule, value, callback, param) }}]"
                      :label="param.label"
                      :prop="param.column"
                      :ref="`fmi${param.column}`">
                      <template v-if="param.h_param_type === tipos.T_LOV">
                        <a-select style="width: 100%"
                                  :showSearch="true"
                                  :filterOption="filterOption"
                                  allowClear
                                  v-model="execValues[param.column]">
                          <a-select-option :value="option.value"
                                           v-for="option in param.items">
                            {{option.label}}
                          </a-select-option>
                        </a-select>
                      </template>
                      <template v-else-if="param.h_param_type === tipos.T_LOV_SQL">
                        <form-model-dropdown style="width: 100%"
                                             v-model="execValues[param.column]"
                                             endpoint="greports/sql_lov_param_values"
                                             :cache="false"
                                             :params="lovSqlParams[param.column]">
                        </form-model-dropdown>
                      </template>
                      <template v-else>
                        <a-select style="width: 40%; padding-right: 3px;"
                                  :disabled="param.interno"
                                  v-model="execOperators[param.column]"
                                  @blur="() => {$refs[`fmi${param.column}`][0].onFieldBlur()}"
                                  @change="($event) => {operadorChanged($event, param); $refs[`fmi${param.column}`][0].onFieldChange()}">
                          <a-select-option :value="option.value"
                                           v-for="option in operadores[param.h_param_type]">
                            {{option.text}}
                          </a-select-option>
                        </a-select>

                        <template v-if="!paramInputHidden.includes(execOperators[param.column])">
                          <template v-if="execOperators[param.column] !== 'BETWEEN'">
                            <template v-if="param.h_param_type === tipos.T_NUMBER">
                              <a-input-number v-model="execValues[param.column]"
                                              @blur="() => {$refs[`fmi${param.column}`][0].onFieldBlur()}"
                                              @change="() => {$refs[`fmi${param.column}`][0].onFieldChange()}"
                                              style="width: 60%"
                              ></a-input-number>
                            </template>
                            <template v-else-if="param.h_param_type === tipos.T_DATE">
                              <a-date-picker style="width: 60%"
                                             v-model="execValues[param.column]"
                                             valueFormat="Y-MM-DD HH:mm:ss"
                                             @blur="() => {$refs[`fmi${param.column}`][0].onFieldBlur()}"
                                             @change="() => {$refs[`fmi${param.column}`][0].onFieldChange()}"
                                             format="Y-MM-DD"></a-date-picker>
                            </template>
                            <template v-else-if="param.h_param_type === tipos.T_TEXT">
                              <a-input v-model="execValues[param.column]"
                                       @blur="() => {$refs[`fmi${param.column}`][0].onFieldBlur()}"
                                       @change="() => {$refs[`fmi${param.column}`][0].onFieldChange()}"
                                       style="width: 60%"
                              ></a-input>
                            </template>
                          </template>
                          <template v-else>
                            <template v-if="param.h_param_type === tipos.T_NUMBER">
                              <a-tooltip>
                                <template slot="title">
                                  El valor debe ser en formato x,y
                                </template>
                                <a-input v-model="execValues[param.column]"
                                         @blur="() => {$refs[`fmi${param.column}`][0].onFieldBlur()}"
                                         @change="() => {$refs[`fmi${param.column}`][0].onFieldChange()}"
                                         style="width: 60%"
                                ></a-input>
                              </a-tooltip>
                            </template>
                            <template v-else-if="param.h_param_type === tipos.T_DATE">
                              <a-range-picker
                                v-model="execValues[param.column]"
                                valueFormat="Y-MM-DD HH:mm:ss"
                                format="Y-MM-DD"
                                @blur="() => {$refs[`fmi${param.column}`][0].onFieldBlur()}"
                                @change="() => {$refs[`fmi${param.column}`][0].onFieldChange()}"
                                style="width: 60%"/>
                            </template>
                          </template>
                        </template>
                      </template>
                    </a-form-model-item>
                  </a-col>
                </template>
                <a-col :span="24" v-if="reporteSeleccionado.id">
                  <a-form-model-item :rules="[{ required: true, message: 'Valor requerido' }]"
                                     label="Descripción" prop="description" has-feedback>
                    <a-input style="width: 100%"
                             v-model="execValues.description"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="24" v-if="reporteSeleccionado.id
                                && (reporteSeleccionado.h_output_type === 'CSV' || reporteSeleccionado.h_output_type === 'TXT')">
                  <a-form-model-item label="Delimitador, por defecto ','">
                    <a-input style="width: 100%" v-model="execValues.delimiter"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="24" v-if="reporteSeleccionado.id">
                  <a-button style="float: right;" type="primary" html-type="submit">
                    Programar Reporte
                  </a-button>
                </a-col>
              </a-row>
            </a-form-model>
          </a-spin>
        </a-card>
      </a-tab-pane>
    </a-tabs>

    <a-collapse>
      <a-collapse-panel key="1" header="Personalizar Reporte">
        <a-checkbox-group v-model="columnasSeleccionadas" style="width: 100%;">
          <a-row :gutter="[16,16]">
            <a-col :span="6" :xs="12" :sm="6" v-for="col in reporteSeleccionado.cols" :key="col.id">
              <a-checkbox :value="col.id" default-checked>
                {{col.label}}
              </a-checkbox>
            </a-col>
          </a-row>
        </a-checkbox-group>
      </a-collapse-panel>
    </a-collapse>

    <a-modal title="Histórico de Reportes"
             :visible="historico.modalVisible"
             width="90%"
             style="top: 20px;"
             @cancel="cerrarHistorico">

      <g-datatable :columns="historico.columns"
                   :endpoint="historico.endpoint"
                   :tableConfig="historico.tableConfig"
                   :actions="historico.actions"
                   :customSlots="historico.customSlots"
                   @action="historicoAction"
                   ref="hDatatable">
        <template slot="estadoRenderer" slot-scope="{text, record}">
          <a-popover title="Log" v-if="record.estado === 'FALLIDO'">
            <template slot="content">
              {{record.log}}
            </template>
            <a-tag color="red">
              {{text}}
            </a-tag>
          </a-popover>
          <a-tag v-else
                 :color="text==='FALLIDO' ? 'red' : (text === 'FINALIZADO' ? 'green' : ( text === 'EN EJECUCION' ? 'blue' : '' ))">
            {{text}}
          </a-tag>
        </template>
      </g-datatable>

      <template slot="footer">
        <a-button key="delete" @click="showHistorialModal">
          Limpiar
          <list-limpiar-historial ref="historial" @lstatus="lstatus = $event"/>
        </a-button>

        <a-button key="reload" @click="reloadHist">
          Actualizar
        </a-button>
        <a-button key="back" @click="historico.modalVisible=false">
          Cerrar
        </a-button>
      </template>
    </a-modal>


  </div>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import JsUtils from '@/util/JsUtils'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  const TIPOS = {
    T_LOV: 'LOV',
    T_TEXT: 'TEXT',
    T_NUMBER: 'NUMBER',
    T_DATE: 'DATE',
    T_LOV_SQL: 'LOV_SQL'
  }

  const OPERADORES = {
    EQUALS: {text: 'IGUAL', value: 'EQUALS', hide_input: false},
    DIFFERENT: {text: 'DIFERENTE', value: 'DIFFERENT', hide_input: false},
    EMPTY: {text: 'ES VACÍO', value: 'EMPTY', hide_input: true},
    NOT_EMPTY: {text: 'NO ES VACÍO', value: 'NOT_EMPTY', hide_input: true},
    GREATER_THAN: {text: 'MAYOR', value: 'GREATER_THAN', hide_input: false},
    GREATER_OR_EQUALS_THAN: {text: 'MAYOR O IGUAL', value: 'GREATER_OR_EQUALS_THAN', hide_input: false},
    LESS_THAN: {text: 'MENOR', value: 'LESS_THAN', hide_input: false},
    LESS_OR_EQUALS_THAN: {text: 'MENOR O IGUAL', value: 'LESS_OR_EQUALS_THAN', hide_input: false},
    BETWEEN: {text: 'ENTRE', value: 'BETWEEN', hide_input: false},
    CONTAINS: {text: 'CONTIENE', value: 'CONTAINS', hide_input: false},
    NOT_CONTAINS: {text: 'NO CONTIENE', value: 'NOT_CONTAINS', hide_input: false}
  }

  export default {
    data () {
      return {
        tipos: TIPOS,
        lstatus: null,
        loading: false,
        reporteSeleccionado: {
          name: ''
        },
        columnasSeleccionadas: [],
        reportDt: {
          endpoint: 'greports_active_allowed',
          columns: [
            {title: 'ID', dataIndex: 'id', sorter: true},
            {title: 'Reporte', dataIndex: 'name', sorter: true},
            {title: 'Description', dataIndex: 'description', sorter: true}
          ],
          actions: {
            title: 'Acciones',
            key: 'acciones',
            width: 90,
            fixed: 'right',
            scopedSlots: {customRender: 'hooverableAction'},
            actions: [
              {
                name: 'detalles',
                text: 'Detalles',
                icon: 'check',
                props: {size: 'small', type: 'link', icon: 'search', style: 'color:green;'}
              }
            ]
          },
          tableConfig: {
            rowKey: 'id'
          }
        },
        historico: {
          modalVisible: false,
          endpoint: 'greports/exec',
          columns: [
            {
              title: 'Estado',
              dataIndex: 'estado',
              sorter: true,
              scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                customRender: 'estadoRenderer'
              }
            },
            {title: 'Reporte', dataIndex: 'nombre_reporte', sorter: true},
            {title: 'Descripción', dataIndex: 'description', sorter: true},
            {title: 'Fecha Creación', dataIndex: 'created_on', sorter: true},
            {title: 'Fecha Inicio', dataIndex: 'start_date', sorter: true},
            {title: 'Fecha Fin', dataIndex: 'end_date', sorter: true}

          ],
          actions: {
            title: 'Acciones',
            key: 'acciones',
            width: 90,
            fixed: 'right',
            scopedSlots: {customRender: 'hooverableAction'},
            actions: [
              {
                name: 'descargar',
                text: 'Descargar',
                icon: 'check',
                props: {size: 'small', type: 'link', icon: 'download', style: 'color:green;'},
                fnVisible: (record) => {
                  return record.estado === 'FINALIZADO'
                },
                fnLoading: (record) => {
                  return this.loadingBtns[record.id] === record.id
                }
              },
              {
                name: 'en_proceso',
                text: 'En Ejecución',
                icon: 'check',
                loading: true,
                props: {size: 'small', type: 'link', icon: 'loading', style: 'color:green;'},
                fnVisible: (record) => {
                  return record.estado === 'EN EJECUCION'
                }
              },
              {
                name: 'reprogramar',
                text: 'Reprogramar',
                props: {size: 'small', type: 'link', icon: 'reload', style: 'color:green;'},
                fnVisible: (record) => {
                  return record.estado === 'FINALIZADO' || record.estado === 'FALLIDO'
                },
                fnLoading: (record) => {
                  return this.loadingBtns[record.id] === record.id
                }
              }
            ]
          },
          tableConfig: {
            rowKey: 'id'
          },
          customSlots: ['estadoRenderer']
        },
        interval: null,
        loadingBtns: {},
        execOperators: {},
        execValues: {},
        operadores: {
          NUMBER: [
            OPERADORES.EQUALS,
            OPERADORES.DIFFERENT,
            OPERADORES.EMPTY,
            OPERADORES.NOT_EMPTY,
            OPERADORES.GREATER_THAN,
            OPERADORES.GREATER_OR_EQUALS_THAN,
            OPERADORES.LESS_THAN,
            OPERADORES.LESS_OR_EQUALS_THAN,
            OPERADORES.BETWEEN
          ],
          DATE: [
            OPERADORES.EQUALS,
            OPERADORES.DIFFERENT,
            OPERADORES.EMPTY,
            OPERADORES.NOT_EMPTY,
            OPERADORES.GREATER_THAN,
            OPERADORES.GREATER_OR_EQUALS_THAN,
            OPERADORES.LESS_THAN,
            OPERADORES.LESS_OR_EQUALS_THAN,
            OPERADORES.BETWEEN
          ],
          TEXT: [
            OPERADORES.EQUALS,
            OPERADORES.DIFFERENT,
            OPERADORES.EMPTY,
            OPERADORES.NOT_EMPTY,
            OPERADORES.CONTAINS,
            OPERADORES.NOT_CONTAINS
          ]
        },
        paramInputHidden: ['EMPTY', 'NOT_EMPTY'],
        lovSqlParams: {},
        paramsTipoSql: {}
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
    },
    methods: {
      reportDtAction (action) {
        switch (action.action) {
          case 'detalles':
            this.reporteSeleccionado = action.record

            this.columnasSeleccionadas.splice(0, this.columnasSeleccionadas.length)

            this.reporteSeleccionado.cols.map(col => {
              this.columnasSeleccionadas.push(col.id)
            })
            break
        }
      },
      filterOption (input, option) {
        return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        )
      },
      programarReporte () {
        this.$refs.reportForm && this.$refs.reportForm.validate(valid => {
          if (valid) {
            this.loading = true
            let params = []
            this.reporteSeleccionado.params.map(param => {
              let operator = this.execOperators[param.column]
              let value = this.execValues[param.column]
              /* Los filtros EMPTY Y NOT_EMPTY no necesitan valor, no lo enviamos  */
              if (!JsUtils.isEmpty(value) || ['EMPTY', 'NOT_EMPTY'].includes(operator)) {
                params.push({
                  param: param.id,
                  operator: operator,
                  value: ['EMPTY', 'NOT_EMPTY'].includes(operator) ? null : value
                })
              }
            })

            let request = {
              id_g_report: this.reporteSeleccionado.id,
              columns: this.columnasSeleccionadas,
              params: params,
              description: this.execValues.description
            }
            if (!JsUtils.isEmpty(this.execValues.delimiter)) {
              request.delimiter = this.execValues.delimiter
            }

            this.httpClient.getInstance().post('greports/programar', request)
              .then(response => {
                Mensajes.success('Correcto', 'Se programó correctamente el reporte.')
              })
              .catch(() => {
                Mensajes.error('Error', 'No fue posible programar el reporte.')
              })
              .then(() => {
                this.loading = false
              })
          }
        })
      },
      historicoAction (action) {
        switch (action.action) {
          case 'reprogramar':
            this.updateBtnLoading(action.record.id, true)
            this.httpClient.getInstance().post('greports/exec/reexec', {
              exec_id: action.record.id
            })
              .then(response => {
                Mensajes.success('Correcto', 'Se programó correctamente el reporte.')
                this.reloadHist()
              })
              .catch(() => {
                Mensajes.error('Error', 'No fue posible programar el reporte.')
              })
              .then(() => {
                this.loading = false
                this.updateBtnLoading(action.record.id, false)
              })
            break
          case 'descargar':
            this.updateBtnLoading(action.record.id, true)
            this.httpClient.getInstance().post('greports/exec/download/' + action.record.id, {}, {responseType: 'arraybuffer'})
              .then(response => {
                let fileURL = new Blob([response.data], {type: response.headers['content-type']})
                fileURL = window.URL.createObjectURL(fileURL)
                let fileLink = document.getElementById('file_link_elm')
                if (fileLink === null) {
                  fileLink = document.createElement('a')
                  fileLink.setAttribute('id', 'file_link_elm')
                  document.body.appendChild(fileLink)
                }

                fileLink.setAttribute('href', fileURL)
                fileLink.setAttribute('download', response.headers['x-nombre-archivo'])
                fileLink.click()
              })
              .catch(() => {
                Mensajes.error('Error descargando', 'No fue posible descargar el archivo, contacte al administrador.')
              })
              .then(() => {
                this.updateBtnLoading(action.record.id, false)
              })
            break
        }
      },
      showHistModal () {
        this.historico.modalVisible = true
        this.reloadHist()
        this.activarAutorefresco(true)
      },
      cerrarHistorico () {
        this.historico.modalVisible = false
        this.activarAutorefresco(false)
      },
      activarAutorefresco (act) {
        if (this.interval !== null) {
          clearInterval(this.interval)
        }
        if (act) {
          this.interval = setInterval(this.reloadHist, 30000)
        }
      },
      reloadHist () {
        this.$refs.hDatatable && this.$refs.hDatatable.loadData()
      },
      deleteHistory () {
        this.$confirm({
          title: 'Confirmación',
          content: '¿Está seguro que desea eliminar el historico?',
          onOk: () => {
            return new Promise((resolve, reject) => {
              this.httpClient.getInstance().post('greports/exec/history', {lstatus: this.lstatus})
                .then(() => {
                  Mensajes.success('Correcto', 'El historico se elimino correctamente')
                  this.$refs.hDatatable && this.$refs.hDatatable.loadData()
                  resolve()
                })
                .catch((error) => {
                  Mensajes.error('Error', 'No fue posible eliminar el historico')
                  reject(error)
                })
            })
          },
          onCancel () {
          }
        })
      },
      showHistorialModal () {
        this.$refs.historial.showModal()
      },
      updateBtnLoading (id, loading) {
        if (loading) {
          this.loadingBtns[id] = id
        } else {
          delete this.loadingBtns[id]
        }
        this.loadingBtns = Object.assign({}, this.loadingBtns)
      },
      operadorChanged (operador, param) {
        if (param.h_param_type === this.tipos.T_DATE) {
          if (operador === 'BETWEEN') {
            this.execValues[param.column] = []
          } else {
            this.execValues[param.column] = null
          }
        }
      },
      custommParamValidator (rule, value, callbackFn, param) {
        let operador = this.execOperators[param.column]
        if (param.h_param_type === this.tipos.T_NUMBER && operador === 'BETWEEN') {
          if (!JsUtils.isEmpty(value)) {
            let tmpVal = value.toString().split(',')
            if (tmpVal.length !== 2) {
              callbackFn('El valor debe tener el formato x,y')
              return new Error('El valor debe tener el formato x,y')
            } else {
              if (JsUtils.isEmpty(tmpVal[0]) || JsUtils.isEmpty(tmpVal[1])) {
                callbackFn('El valor debe tener el formato x,y')
                return new Error('El valor debe tener el formato x,y')
              }
            }
          }
        }
        callbackFn()
      }
    },
    destroyed () {
      if (this.interval !== null) {
        clearInterval(this.interval)
      }
    },
    watch: {
      lstatus () {
        if (!JsUtils.isEmpty(this.lstatus)) {
          this.deleteHistory()
        }
      },
      reporteSeleccionado () {
        let resultValues = {
          description: '',
          delimiter: ''
        }
        let resultOperators = {}
        let paramsTipoSql = {}

        this.reporteSeleccionado.params.map(param => {
          resultOperators[param.column] = 'EQUALS'
          resultValues[param.column] = null

          if (param.h_param_type === this.tipos.T_LOV_SQL) {
            paramsTipoSql[param.column] = param.id
          }
        })

        this.execOperators = resultOperators
        this.execValues = resultValues
        this.paramsTipoSql = paramsTipoSql
      },
      execValues: {
        deep: true,
        handler () {
          let lovSqlParams = {}
          let tmpParams = {}

          for (let prop in this.execValues) {
            if (this.execValues.hasOwnProperty(prop)) {
              let propValue = this.execValues[prop]
              let operador = this.execOperators[prop]
              if (operador === 'EQUALS' && !JsUtils.isEmpty(propValue)) {
                tmpParams[prop] = propValue
              }
            }
          }

          for (let prop in this.paramsTipoSql) {
            if (this.paramsTipoSql.hasOwnProperty(prop)) {
              let idParam = this.paramsTipoSql[prop]
              lovSqlParams[prop] = {...tmpParams, id_param: idParam}
            }
          }

          this.lovSqlParams = lovSqlParams
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/GReport/GReport.vue